import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { API_CONFIG } from "../../../common/constant";
import { useNavigate, useSearchParams } from "react-router-dom";
import Subscription from "../component/subscription";
import axios from "axios";
import { connect } from "react-redux";
import { createAction } from "../../../common/utility";

const SubscriptionPaymentContainer = ({ addNotification }) => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [decodedData, setDecodedData] = useState(null);
  const [paymentDoneStatus, setPaymentDoneStatus] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = new Date().getTime();
      if (
        !decoded.userId ||
        !decoded.centerId ||
        !decoded.centerName ||
        !decoded.userEmail ||
        !decoded.currency ||
        !decoded.productId ||
        !decoded.amount ||
        !decoded.expireDate ||
        currentTime > decoded.expireDate
      ) {
        navigate("/login");
        return;
      }
      setDecodedData(decoded);
    } catch (error) {
      navigate("/login");
    }
  }, [token, navigate]);

  const handlePayment = (productId, centerId, userId) => (stripeToken) => {
    setIsPaymentLoading(true);
    axios
      .post(API_CONFIG.paymentPublic, {
        stripeToken: stripeToken.id,
        productId,
        centerId,
        userId,
      })
      .then(() => {
        setIsPaymentLoading(false);
        setPaymentDoneStatus(true);
        addNotification({
          type: "success",
          message: "Subscription payment completed successfully.",
        });
      })
      .catch((error) => {
        setIsPaymentLoading(false);
        let message = "Payment failed. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }
        setPaymentDoneStatus(false);
        addNotification({
          type: "error",
          message: message,
        });
      });
  };

  if (!decodedData) {
    return null;
  }

  return (
    <>
      <Subscription
        decodedData={decodedData}
        handlePayment={handlePayment}
        paymentDoneStatus={paymentDoneStatus}
        isPaymentLoading={isPaymentLoading}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  addNotification: (data) => dispatch(createAction("ADD_NOTIFICATION", data)),
});

export default connect(null, mapDispatchToProps)(SubscriptionPaymentContainer);
